import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import TenantService from "../Services/TenantService/TenantService";

export const get = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return TenantService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const lastPage = false;
      const status = data.message;
      store.setState({
        isLoading,
        data,
        header: response.headers,
        lastPage,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  TenantService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }

      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getByID = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return TenantService.getByID(value)
    .then((response) => {
      store.state.tenant = response.data;
      store.setState({
        isLoading: false,
        header: response.headers,
        status: response.data.message,
      });

      return response.data;
    })
    .catch((error) => {
      const response = error.response;
      store.setState({
        isLoading: false,
        status: response.status,
      });
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await TenantService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Tenant", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const put = async (store, value, index) => {
  try {
    console.log(value);
    console.log("<<<<<<");
    const response = await TenantService.putData(value);
    const data = response.data;
    notifUtils("Successfully Updated Tenant", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deleted = async (store, query) => {
  try {
    const response = await TenantService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Deleted User", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
